import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "splitByUpperCase" })
export class SplitByUpperCasePipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (!value) return "";
    return value
      .split(/(?<=[a-z0-9])(?=[A-Z])|(?<=[A-Z])(?=[A-Z][a-z])/)
      .join(" ");
  }
}
